import React, { Component } from 'react';
import { connect } from 'react-redux';
import orderBy from 'lodash/orderBy';
import groupBy from 'lodash/groupBy';
import mapValues from 'lodash/mapValues';
import AgentDetailsRow from './AgentDetailsRow';
import AgentQueueRow from './AgentQueueRow';
import Loader from './Components/Loader';
import { setItem, getItem } from '../utils/storage';
import { getServiceAvailabilityCount, getServiceUnavailabilityCount } from '../utils/utils';
import IncomingCallIcon from '../assets/img/incoming-call.svg';
import "../agent/Styles/darktheme.css";
import "../agent/Styles/blacktheme.css";
import "../agent/Styles/highContrast.css";

class AgentsDetails extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchFilter: '',
			hideMe: getItem('hideMeSettings') == 'true' ? true : false
		};
	}

	/**
	   * render list of agents or supervisors
	   * @param  {array} users
	   * @param  {string} type  agents or supervisors
	   */
	renderList = (availability, showOffline) => {
		//const users = [...this.props.agents, ...this.props.supervisors];
		const users = [...this.props.agents];
		let sortedData = orderBy(users, [user => user.name ? user.name.toLowerCase() : ''], ['asc'])
		if (!showOffline) {
			sortedData = orderBy(sortedData, 'busy', 'desc');
		}

		// removed current user if hide me selected
		if (this.state.hideMe) {
			// console.log(this.props.agentInfo, 'agentInfo')
			sortedData = sortedData.filter(agent => agent.extension !== this.props.agentInfo.extension)
		}

		return (
			sortedData.filter(item => item.name &&
				(item.name.toLowerCase().includes(this.props.searchFilter.toLowerCase()) ||
				item.surname_1.toLowerCase().includes(this.props.searchFilter.toLowerCase()) ||
					item.extension.includes(this.props.searchFilter))
			)
				.map(user => {
					if (!showOffline || user.busy) {
						if (user.availability == (availability == 'available' ? true : false) && (user.online || user.busy)) {
							return (
								<AgentDetailsRow
									key={user.id}
									user={user}
									type={'user'}
									availability={availability}
								/>
							);
						}
					} else {
						if (!user.online) {
							return (
								<AgentDetailsRow
									key={user.id}
									user={user}
									type={'users'}
									availability={availability}
								/>
							);
						}
					}
				})
		)
	}
	
	renderListQueue = (queuedCalls) => (
		Object.keys(queuedCalls).map(type => (
			<div key={type}>
				<div className={`queueCallRow${this.props.theme} active`} style={{ width: '70%' }}>
					<b>{queuedCalls[type][0].service_name}</b>
				</div>
				<div className={`queueCallRow${this.props.theme} active text-right`} style={{ width: '30%' }}>
					{/* <b>{queuedCalls[type].length}</b> */}
					<div className="status-grp">
						<span>
							<img src={IncomingCallIcon} className={`incoming-call-icon${this.props.theme}`} alt="test"></img>
							{queuedCalls[type].length}
						</span>
						<span style={{ margin: '0 6px' }}>
							<span className="agent-status-row avail-agent-status"></span>
							{getServiceAvailabilityCount(queuedCalls[type][0].service_id)}
						</span>
						<span><span className="agent-status-row unavail-agent-status"></span>
							{getServiceUnavailabilityCount(queuedCalls[type][0].service_id)}
						</span>
					</div>
				</div>
				<div className={`queueCallRow${this.props.theme}`} style={{ width: '35%' }}>
					<b>{this.props.translations.phoneNumber[this.props.selectedLanguage]}</b>
				</div>
				<div className={`queueCallRow${this.props.theme}`} style={{ width: '35%' }}>
					<b>{this.props.translations.ring[this.props.selectedLanguage]}</b>
				</div>
				<div className={`queueCallRow${this.props.theme}`} style={{ width: '30%' }}>
					<b>{this.props.translations.onQueue[this.props.selectedLanguage]}</b>
				</div>
				{queuedCalls[type].map(item => (
					<AgentQueueRow
						key={item.linkedid}
						item={item}
					/>
				))}
			</div>
		))
	)

	handleOnHideMeClicked = () => {
		setItem('hideMeSettings', !this.state.hideMe);

		this.setState({
			hideMe: !this.state.hideMe
		})
	}

	render() {
		const {
			agents,
			queuedCalls,
			agentsLoadComplete,
			translations,
			selectedLanguage
		} = this.props;
		const queuedCallsByService = mapValues(groupBy(queuedCalls, 'service_name'));
		let availableAgentsList = this.renderList('available');
		let unavailableAgentsList = this.renderList('unavailable');
		let isAvilableAgentExisit = availableAgentsList.some(service => service);
		let isUnavilableAgentExisit = unavailableAgentsList.some(service => service);

		return (
			<div className={`container-fluid${this.props.theme}`} style={{ overflow: 'hidden' }}>
				<div className="row">
					<div className="col-md-4">
						<div className="row">
							<div className="col-md-12">
								<h4 className={`divtext${this.props.theme}`}>{translations.callsInQueue[selectedLanguage]}</h4>
								<div className="table-responsive">
									<table className={`table-fixed table table${this.props.theme} table-condensed table-hover${this.props.theme} small m-a-0`}>
										<thead>
											<tr>
												<th />
												<th />
												<th />
											</tr>
										</thead>
										<div style={{ height: 'calc(-117px + 100vh)', overflow: 'auto' }}>
											{this.renderListQueue(queuedCallsByService)}
											{queuedCalls.length == 0 &&
												<div className={`panel-body${this.props.theme} text-center small`}>
													{!agentsLoadComplete && <span style={{ fontSize: 12 }}>{translations.noCallsInQueue[selectedLanguage]}</span>}
													{agentsLoadComplete && <span style={{ fontSize: 12 }}>{translations.noQueuedCallsNow[selectedLanguage]}</span>}
												</div>
											}
										</div>
									</table>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-4" style={{ height: 'calc(100vh - 66px)' }}>
						<div className='checkbox-container two-column'>
							<div className="checkbox checkbox-style">
								<label className="control control--checkbox checkbox-label">{translations.hideMeText[selectedLanguage]}
									<input
										type="checkbox"
										checked={this.state.hideMe}
										onChange={this.handleOnHideMeClicked}
									/>
									<div className="control__indicator" />
								</label>
							</div>
						</div>
						<div style={{ height: 'calc(100% - 25px)' }}>
							<div style={{ height: '100%' }}>
								<div style={{ fontSize: 18, padding: '5px 0px', height: 40}} className={`divtext${this.props.theme}`}>
									{translations.available[selectedLanguage]}
								</div>
								<div className={`table-responsive extra-responsive divtext${this.props.theme}`} style={{ height: 'calc(100% - 40px)', }}>
									<table className={`table-fixed table table${this.props.theme} table-condensed table-hover${this.props.theme} small m-a-0`}>
										<thead>
											<tr>
												<th style={{ width: 150 }}>{translations.agents[selectedLanguage]}</th>
												<th style={{ width: 150 }} >{translations.state[selectedLanguage]}</th>
												<th style={{ width: 30 }}>{translations.time[selectedLanguage]}</th>
											</tr>
										</thead>
										<tbody>
											{availableAgentsList}
											{agents.length == 0 && <tr>
												{!agentsLoadComplete && <td><Loader width="20px" height="20px" /></td>}
												{agentsLoadComplete && <td>{translations.noAgentsInService[selectedLanguage]}</td>}
											</tr>}
											{!isAvilableAgentExisit && <tr><p className="no-service-txt">{translations.noResultsText[selectedLanguage]}</p></tr>}
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-4" style={{ height: 'calc(100vh - 66px)' }}>
						<div className={`checkbox-container${this.props.theme} three-column`}>
							<div className="checkbox checkbox-style">
								<label className="control control--checkbox checkbox-label">{translations.hideMeText[selectedLanguage]}
									<input
										type="checkbox"
										checked={this.state.hideMe}
										onChange={this.handleOnHideMeClicked}
									/>
									<div className="control__indicator" />
								</label>
							</div>
						</div>
						<div style={{ height: 'calc(100% - 25px)' }}>
							<div style={{ height: '100%' }}>
								<div style={{ fontSize: 18, padding: '5px 0px', height: 40}} className={`divtext${this.props.theme}`}>
									{translations.unavailable[selectedLanguage]}
								</div>
								<div className={`table-responsive extra-responsive divtext${this.props.theme}`} style={{ height: 'calc(100% - 40px)'}}>
									<table className={`table-fixed table${this.props.theme} table-condensed table-hover${this.props.theme} small m-a-0`}>
										<thead>
											<tr>
												<th style={{ width: 150 }}>{translations.agents[selectedLanguage]}</th>
												<th style={{ width: 150 }} >{translations.state[selectedLanguage]}</th>
												<th style={{ width: 30 }}>{translations.time[selectedLanguage]}</th>
											</tr>
										</thead>
										<tbody>
											{unavailableAgentsList}
											{agents.length == 0 && <tr>
												{!agentsLoadComplete && <td><Loader width="20px" height="20px" /></td>}
												{agentsLoadComplete && <td>{translations.noAgentsInService[selectedLanguage]}</td>}
											</tr>}
											{!isUnavilableAgentExisit && <tr><p className="no-service-txt">{translations.noResultsText[selectedLanguage]}</p></tr>}
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		agents: state.agentsAndSupervisors.agents,
		agentsLoadComplete: state.agentsAndSupervisors.agentsLoadComplete,
		supervisors: state.agentsAndSupervisors.supervisors,
		agentInfo: state.agentInfo,
		queuedCalls: state.queuedCalls.queuedCalls,
		translations: state.languages.translations,
		selectedLanguage: state.languages.selectedLanguage,
		darkMode: state.common.darkMode,
		theme: state.common.theme,
	};
}

export default connect(mapStateToProps)(AgentsDetails);


// WEBPACK FOOTER //
// ./src/agent/AgentsDetails.js